module.exports = __webpack_public_path__ + "themes/fq/sprite/win-frame.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/win-frame.png
// module id = 74
// module chunks = d-game